export enum StorageKey {
  CompositionTopNOverride = 'composition-top-n-override',
  EconomicImpactState = 'economic-impact-state',
  RecentEntitiesPrefix = 'recent-entities-',
  SkipDbeCache = 'skip-dbe-cache',
  SkipMwCache = 'skip-mw-cache',
  SkipShareOfPostingsScaling = 'skip_share_of_postings_scaling',
  UserPreferencesPrefix = 'user-preferences-',
}
